import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const GhostEchoAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 1; i <= 3; i++) {
    const p = Math.max(0, progress - i * 0.1);
    if (p <= 0) continue;
    ctx.globalAlpha = (1 - p) * 0.5;
    ctx.lineWidth = 5;
    drawBlastShape(ctx, e, e.maxRadius * (1 + p));
    ctx.stroke();
  }
};

registerBlastAnimation('GHOST_ECHO', GhostEchoAnimation);
